import styled, { keyframes, css } from 'styled-components';

export const FloatingIcon = styled('div')({});

const visibleAnimation = keyframes({
  '0%': {
    opacity: 0,
    transform: 'scale(0)',
  },
  '85%': {
    opacity: 1,
    transform: 'scale(1.2)',
  },
  '100%': {
    opacity: 1,
    transform: 'scale(1)',
  },
});

export const Visible = styled('div')(
  () => css`
    opacity: 0;
    visibility: none;
    &.visible {
      visibility: visible;
      animation-name: ${visibleAnimation};
      animation-duration: 0.3s;
      animation-timing-function: ease-out;
      animation-delay: ${Math.round(Math.random() * 5)}s;
      animation-fill-mode: forwards;
    }
  `
);

const floatingAnimation = keyframes({
  '0%': {
    transform: 'rotate(0deg) translateX(10rem) rotate(0deg) rotate(-5deg)',
  },
  '50%': {
    transform: 'rotate(180deg) translateX(30rem) rotate(-180deg) rotate(5deg)',
  },
  '100%': {
    transform: 'rotate(360deg) translateX(10rem) rotate(-360deg) rotate(-5deg)',
  },
});

export const Floating = styled('div')(
  () => css`
    animation-name: ${floatingAnimation};
    animation-duration: ${Math.round(Math.random() * 10 + 5)}s;
    animation-direction: ${Math.random() > 0.5 ? 'normal' : 'reverse'};
    animation-timing-function: linear;
    animation-iteration-count: infinite;
  `
);

export const Icon = styled('div')(({ theme }) => ({
  height: '60rem',
  width: '60rem',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: theme.colors.secondary_background,
  borderRadius: '50%',
  boxShadow: `0 10rem 10rem ${theme.colors.black}0A`,
  transform: `scale(${
    1 + (Math.round(Math.random() * 3) / 10) * (Math.random() > 0.5 ? 1 : -1)
  })`,
  '& svg': {
    height: '28rem',
  },
  '@media (max-width: 1200px)': {
    height: '50rem',
    width: '50rem',
    '& svg': {
      height: '26rem',
    },
  },
  '@media (max-width: 768px)': {
    height: '40rem',
    width: '40rem',
    '& svg': {
      height: '24rem',
    },
  },
}));
